<template>
  <div data-app>
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>
    <v-card>
      <v-card-title>Rate Limiters</v-card-title>
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="rate_limiters"
        :search="search"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 50, 100, 250, -1], // -> Add this example
          showFirstLastPage: false,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
        }"
        item-key="id"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on"
                  >New Item</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form ref="newForm" lazy-validation>
                    <v-container>
                      <v-row>
                        <v-text-field
                          v-model="editedItem.max_rps"
                          label="Requests Per Second*"
                          type="number"
                          :rules="[(v) => !!v || 'Limit is required', (v) => !v || (parseInt(v) !== NaN && parseInt(v) > 0) || 'Must be greater than 0']"
                        ></v-text-field>
                      </v-row>
                      <v-row>
                        <v-checkbox
                          v-model="editedItem.by_source"
                          label="By Source"
                        ></v-checkbox>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="editItem(item)">mdi-pencil</v-icon>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/common/api.service";
import Errors from "@/common/errors";

export default {
  mounted() {
    api
      .query("beta/waf/rate_limiters")
      .then((response) => (this.rate_limiters = response.data.rate_limiters))
      .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)))
      .finally(() => (this.loading = false));
  },
  data: () => ({
    selected: [],
    headers: [
      {
        text: "ID",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Requests per Second", value: "max_rps" },
      { text: "By Source", value: "by_source" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    rate_limiters: [],
    errors: [],
    loading: true,
    dialog: false,
    editedIndex: -1,
    editedItem: {
      id: "",
      max_rps: null,
      by_source: false,
    },
    defaultItem: {
      id: "",
      max_rps: null,
      by_source: false,
    },
    search: "",
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    editItem(item) {
      this.editedIndex = this.rate_limiters.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        api.delete("beta/waf/rate_limiters/" + item.id).then((response) => {
          const index = this.rate_limiters.indexOf(item);
          this.rate_limiters.splice(index, 1);
        });
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (!this.$refs.newForm.validate()) return;
      
      if (this.editedIndex > -1) {
        api
          .patch("beta/waf/rate_limiters/" + this.editedItem.id, {
            max_rps: this.editedItem.max_rps,
            by_source: this.editedItem.by_source,
          })
          .then((response) => {
            Object.assign(
              this.rate_limiters.find((val) => val.id == response.data.id),
              response.data
            );
          })
          .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)));
      } else {
        api
          .post("beta/waf/rate_limiters", {
            max_rps: this.editedItem.max_rps,
            by_source: this.editedItem.by_source,
          })
          .then((response) => {
            this.rate_limiters.push(response.data);
          })
          .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)));
      }
      
      this.close();
    },
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
};
</script>
